import { Box, Typography, styled, Button } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "60px",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 700,
  color: colors.text.primary,
  textAlign: "center",
  fontFamily: "Sora, sans-serif",
  marginBottom: "32px",
});

export const FormContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const InputLabel = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: colors.text.secondary,
  fontFamily: "Nunito, sans-serif",
  marginBottom: "4px",
});

export const StyledInput = styled("input")({
  width: "100%",
  height: "48px",
  border: `1px solid ${colors.border.medium}`,
  borderRadius: "8px",
  padding: "0 16px",
  fontSize: "16px",
  fontFamily: "Nunito, sans-serif",
  color: colors.text.primary,
  backgroundColor: colors.background.secondary,
  outline: "none",

  "&:focus": {
    borderColor: colors.primary.main,
  },

  "&::placeholder": {
    color: colors.text.secondary,
  },
});

export const StyledTextarea = styled("textarea")({
  width: "100%",
  height: "100px",
  border: `1px solid ${colors.border.medium}`,
  borderRadius: "8px",
  padding: "12px 16px",
  fontSize: "16px",
  fontFamily: "Nunito, sans-serif",
  color: colors.text.primary,
  backgroundColor: colors.background.secondary,
  outline: "none",
  resize: "none",
  lineHeight: "1.5",

  "&:focus": {
    borderColor: colors.primary.main,
  },

  "&::placeholder": {
    color: colors.text.secondary,
  },
});

export const InputWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const FieldsRow = styled(Box)({
  display: "flex",
  gap: "16px",
  width: "100%",
});

export const FieldHalf = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  marginTop: "32px",
});

export const CancelButton = styled(Button)({
  height: "48px",
  minWidth: "140px",
  borderRadius: "8px",
  border: `1px solid ${colors.border.medium}`,
  color: colors.primary.main,
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  fontFamily: "Nunito, sans-serif",
  backgroundColor: "transparent",

  "&:hover": {
    backgroundColor: colors.background.lightBlue,
    borderColor: colors.border.medium,
  },
});

export const SubmitButton = styled(Button)({
  height: "48px",
  minWidth: "160px",
  borderRadius: "8px",
  backgroundColor: colors.amber.main,
  color: "#FFFFFF",
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  fontFamily: "Nunito, sans-serif",
  boxShadow: "none",

  "&:hover": {
    backgroundColor: colors.amber.dark,
    boxShadow: "none",
  },

  "&:disabled": {
    backgroundColor: colors.border.light,
    color: colors.text.secondary,
  },
});
